import React from 'react';
import { CONNECTION_KEY } from '../../contrants';
import { ENTITY_ACTIVATED_STATE } from '../../../../constants/common';
import { DeviceActivityState } from '../../../DeviceActivityState/DeviceActivityState';
import { IActionsDropdown, IActionsTag } from '../../../../types/tableDropdown';
import InteractiveButton from '../../../InteractiveButton/InteractiveButton';

type Props = {
  record: any;
  defaultKeys: string[];
  actions?: IActionsDropdown[];
};

const TableRow: React.FC<Props> = ({ record, defaultKeys, actions = [] }) => {
  return (
    <>
      {defaultKeys.map((key, index) => {
        const isStartPadding = index === 0 ? 'pl-5' : '';
        const isEndPadding = (index === defaultKeys.length - 1 && actions.length === 0) ? 'pr-5' : '';
        const isRightPadding = index === defaultKeys.length - 1 ? '' : 'pr-2';

        const value = record[key];

        if (key === CONNECTION_KEY) {
          return (
            <td className="text-xs leading-6" key={key}>
              <p className={`py-2 ${isStartPadding} ${isEndPadding} ${isRightPadding}`}>
                <DeviceActivityState active={value} />
              </p>
            </td>
          );
        }

        if (typeof value === 'boolean') {
          const text = value ? ENTITY_ACTIVATED_STATE.ACTIVATED : ENTITY_ACTIVATED_STATE.DEACTIVATED;
          return (
            <td key={key} className="text-xs leading-6">
              <p className={`inline-flex rounded-full bg-opacity-10 px-2 py-0.5 text-sm font-medium ${value ? 'bg-success text-success' : 'bg-danger text-danger'}`}>
                {text}
              </p>
            </td>
          );
        }

        return (
          <td key={key} className="text-xs leading-6">
            <p className={`py-2 ${isStartPadding} ${isEndPadding} ${isRightPadding}`}>
              {value}
            </p>
          </td>
        );
      })}

      {actions.length > 0 && (
        <td className="pr-5">
          <div className="flex flex-row justify-end items-center gap-x-1">
            {actions.map((action, idx) => {
              const isShow = typeof action.isShow !== 'function' || action.isShow(record);
              if (!isShow) return null;

              return (
                <InteractiveButton
                  disabled={action.loading}
                  onClick={() => action.onClick(record.id, record)}
                  key={`action-${idx}`}
                  customType="min-h-fit min-w-fit max-h-fit max-w-fit border border-foggy-mist rounded active:border-primary cursor-pointer"
                  style={{ padding: '8px' }}
                  as={action.tag || IActionsTag.Button}
                >
                  {action.icon(record)}
                </InteractiveButton>
              );
            })}
          </div>
        </td>
      )}
    </>
  );
};

export default TableRow;